module.exports = __webpack_public_path__ + "static/media/icon-pass.69df9b99.svg";